import { headers} from "../../common/credentials";

const port = "1100";
const port1 = "50005";
const baseUrl = "http://172.16.40.14:";


export const getReportGridDataFromServer = () => {
    let url = baseUrl + port + "/api/v2/medical_insurance/generic/reports/";
    return ([headers, url]);
} 

export const getFileProcessFromServer = () => {
    let url = baseUrl + port + "/api/v2/medical_insurance/execute_batch_data/";
    return ([headers, url]);
}

export const Fetchexecutequery = () => {
    let url = baseUrl + port1 + "/api/v2/user_modules/getexecutequery/";
    return ([headers, url]);
}
